//@ts-nocheck

import React, { Fragment, useEffect, useState } from "react"
import styled from "styled-components"
import { Styles } from "../../config"
import { Icon, Typography } from "../../typo-components"
import { filterAmount, filterIncludes, filterIncludesTime, TableFilter } from "./TableFilter"

export const getTableTextAlignment = ({
	header,
	isLastRow
}) => {
	let ret = "left"
	if (isLastRow === false) ret = "center"
	else if (
		header?.isForm ||
		header?.type === "form" ||
		header?.type === "button"
		|| header?.type === 'custom'
	)
		ret = "center"
	else if (header?.type === "amount" || header?.type === "percent") ret = "right"
	return ret
}

const TableData = styled.td`
	text-align: ${(props) => getTableTextAlignment({ header: props?.header })};
	padding: 2.5px 10px;

	${(props) => props?.borderConfig?.join(" ") || ""}
`

const TableHeader = styled.th`
	background: ${(props) => Styles.Color[props.header?.background || "transparent"]};
	text-align: ${(props) =>
		getTableTextAlignment({
			header: props.header,
			isLastRow: props.isLastRow
		})};

	padding: ${(props) => {
		if (props?.header?.id?.startsWith("anchor")) return "0px"
		else return "10px"
	}};

	white-space: nowrap;
	cursor: ${(props) => "default"};
	${(props) => !props.isLastRow && "border-bottom:  none!important"};
	vertical-align: bottom;
	${(props) => {
		return props.borderConfig?.join(" ") || ""
	}}
`

const TableRow = styled.tr`
	//background: ${(props) => (props.index % 2 === 0 ? Styles.Color.primary05 : "transparent")};
	height: 45px;
`

const TableVessel = styled.table`
	width: 100%;
	margin: 25px 0px 0px;
	border-collapse: collapse;
	// table-layout: fixed;

	& td {
		vertical-align: middle;
	}
`

function setBorders(args) {
	const { header, index, isTopLevel, columnsLength } = args
	const cell = { borderLeft: "", borderRight: "" }

	if (isTopLevel) {
		cell.borderLeft = `border-left: 2px solid #e1e1e1;`
		cell.borderRight = `border-right: 2px solid #e1e1e1;`
	} else if (index === 0) cell.borderLeft = `border-left: 2px solid #e1e1e1;`
	else if (index === columnsLength - 1) cell.borderRight = `border-right: 2px solid #e1e1e1;`

	let headers = {}

	if (header?.columns?.length) {
		const columnsLength = header?.columns?.length

		headers = header?.columns.reduce((headers, header, index) => {
			const childHeaders = setBorders({ header, index, isTopLevel: false, columnsLength })
			return { ...childHeaders, ...headers }
		}, {})
	}

	return { ...headers, [header?.accessor]: cell }
}

const Table = ({
	headerGroups,
	prepareRow,
	getTableProps,
	getTableBodyProps,
	page,
	config,
	Headers
}) => {
	const [formHeaderGroup, setFormHeaderGroup] = useState([])
	const [formHeaderColSpans, setFormHeaderColSpans] = useState({})
	const [columnBorderConfig] = useState(
		Headers?.reduce((acc, header) => {
			if (header?.columns?.length > 1) {
				const headers = setBorders({
					header,
					index: 0,
					isTopLevel: true,
					columnsLength: 1
				})
				return { ...headers, ...acc }
			}
			return acc
		}, {})
	)

	useEffect(() => {
		const formHeaderGroup = []
		const formHeaderColSpans = {}
		headerGroups.forEach((headerGroup) => {
			headerGroup.headers.forEach((header) => {
				if (header?.type === "form") {
					header?.formConfig?.Inputs?.forEach((input) => {
						if (typeof input.disableRender === "function" ? !input.disableRender({}) : !input.disableRender) {
							formHeaderGroup.push({
								Header: input.label,

								background: header?.background
							})
							if (!formHeaderColSpans[header?.id]) formHeaderColSpans[header?.id] = 1
							else formHeaderColSpans[header?.id]++
						}
					})
				} else {
					let isRendered = !header?.disableRender
					if (typeof header?.id === "string" && header?.id?.includes("filter")) isRendered = false

					if (isRendered) formHeaderGroup.push({ Header: "" })
				}
			})
		})
		setFormHeaderColSpans(formHeaderColSpans)
		setFormHeaderGroup(formHeaderGroup)
	}, [])

	return (
		<TableVessel {...getTableProps()}>
			<thead>
				{headerGroups.map((headerGroup, headerGroupIndex) => {
					const isLastHeaderGroup = Boolean(headerGroupIndex === headerGroups?.length - 1)
					return (
						<TableRow key={`table-header-group-${headerGroupIndex}`}>
							{headerGroup.headers.reduce((acc, header, headerIndex) => {
								let isRendered = !header?.disableRender
								if (typeof header?.id === "string" && header?.id?.includes("filter")) isRendered = false
								else if (header?.headers?.every((header) => header?.disableRender)) isRendered = false

								if (isRendered) {
									const isSortable = header?.type !== "button" && isLastHeaderGroup

									const headerProps = header?.getHeaderProps(isSortable && header?.getSortByToggleProps())
									headerProps.onClick = null
									if (header?.type === "form" && header?.columns?.length) {
										headerProps.colSpan = header?.columns?.filter((column) => !column?.disableRender)?.length
									}

									if (isSortable) {
										headerProps.title = "Click here to filter and sort"
										if(header)
										{
											header.filter = filterIncludes
											if (header?.type === "ts" || header?.type === "date") header.filter = filterIncludesTime
											else if (header?.type === "amount") header.filter = filterAmount
										}
									}

									let borderConfig = []
									if (columnBorderConfig?.[header?.id]) {
										borderConfig = Object.values(columnBorderConfig?.[header?.id])
									} else if (columnBorderConfig?.[header?.originalId]) {
										borderConfig = Object.values(columnBorderConfig?.[header?.originalId])
									}

									acc.push(
										<TableHeader
											isSortable={isSortable}
											isLastRow={isLastHeaderGroup}
											key={`table-header-${headerIndex}`}
											header={header}
											borderConfig={borderConfig}
											{...headerProps}
										>
											{isSortable ? (
												header?.render(TableFilter)
											) : typeof header?.Header === "string" ? (
												<Fragment>
													<Typography
														variant="t6"
														weight="normal"
														textAlign={getTableTextAlignment({
															header,
															isLastRow: isLastHeaderGroup
														})}
														color={header?.color || "gray"}
														margin=""
														style={{ whiteSpace: "nowrap" }}
													>
														{header?.Header}
													</Typography>
												</Fragment>
											) : (
												header?.render("Header")
											)}
											{/* @ts-ignore */}
											{header?.isSorted && (
												<Icon
													size="very-small"
													name={header?.isSortedDesc ? "keyboard_arrow_down" : "keyboard_arrow_up"}
												></Icon>
											)}
											{Boolean(header?.filterValue) && <Icon size="very-small" name={"filter_alt"}></Icon>}
										</TableHeader>
									)
								}

								return acc
							}, [])}
						</TableRow>
					)
				})}
			</thead>

			<tbody {...getTableBodyProps()}>
				{page.reduce((rows, row, index) => {
					prepareRow(row)

					rows.push(
						<TableRow key={`table-row-${index}`} index={index} {...row?.getRowProps({ style: { background: "" } })}>
							{Boolean(row?.cells?.length) &&
								row?.cells?.reduce((cells, cell, index) => {
									const header = cell?.column

									let isRendered = !cell.column?.disableRender
									let renderType = "Text"

									if (typeof header?.id === "string" && header?.id?.includes("filter")) isRendered = false
									else if (header?.isForm) isRendered = false

									if (isRendered) {
										if (header?.type === "custom" || header?.type === "form") renderType = "Cell"
										else if (header?.type === "button" && header?.buttonConfig) renderType = "Button"
										else if (header?.type === "ellipsis") renderType = "Ellipsis"

										if (header?.type === "form") {
											cells.push(cell.render(renderType))
										} else {
											const props = cell?.getCellProps()
											let borderConfig = []

											if (columnBorderConfig?.[header?.id]) {
												borderConfig = Object.values(columnBorderConfig?.[header?.id])
											}

											cells.push(
												<TableData
													{...props}
													key={`table-data-${index}`}
													header={header}
													borderConfig={borderConfig}
													style={header?.type === "button" ? { verticalAlign: "middle" } : {}}
												>
													{cell.render(renderType)}
												</TableData>
											)
										}
									}

									return cells
								}, [])}
						</TableRow>
					)

					return rows
				}, [])}
			</tbody>
		</TableVessel>
	)
}

export default Table
